export enum MessageChannel {
  EMAIL = 'Email',
  PUSH_NOTIFICATION = 'PushNotification',
  SMS = 'Sms',
  WHATSAPP = 'WhatsApp'
}
